import type { CategoryDefinition } from '@/types';

export const pressureWashingCategories: readonly CategoryDefinition[] = [
  { id: 'pressure-washing.surfaces', name: 'Surfaces', icon: 'layers',  color: 'blue',    order: 1, description: 'Flat areas priced by measured size' },
  { id: 'pressure-washing.exterior', name: 'Exterior', icon: 'home',    color: 'sky',     order: 2, description: 'Walls, siding and boundaries' },
  { id: 'pressure-washing.roofing',  name: 'Roofing',  icon: 'droplet', color: 'cyan',    order: 3, description: 'Roof and gutter work at height' },
  { id: 'pressure-washing.sealing',  name: 'Sealing',  icon: 'shield',  color: 'emerald', order: 4, description: 'Protective coatings after cleaning' },
];
